import { Button, Divider, Form, Input, InputNumber, Select, Switch } from 'antd';
import { useEffect } from 'react';
import { formItemLayout, tailFormItemLayout } from 'utils/formConfig';
import { WIDGET_TYPE_OPTIONS } from './config';

const { TextArea } = Input;

const HomeWidgetForm = ({
  form,
  submiting,
  onFinish,
  initialValues = {} as Record<string, any>,
  name,
}) => {
  const isEdit = !!initialValues?.id;
  const type = Form.useWatch('type', form);

  useEffect(() => {
    form.setFieldsValue({ is_active: true, ordering: 0, ...initialValues });
  }, [form, initialValues]);

  return (
    <Form
      {...formItemLayout}
      form={form}
      name={name || 'home_widget_form'}
      onFinish={onFinish}
      initialValues={{ is_active: true, ordering: 0, ...initialValues }}
      scrollToFirstError
    >
      <Form.Item
        name="type"
        label="Type"
        rules={[{ required: true, message: 'Please select a widget type' }]}
        tooltip={
          isEdit
            ? 'Type cannot be changed after creation — changing it would orphan any existing content (menu items / banners / callout card)'
            : 'Which section of the home screen this widget renders'
        }
      >
        <Select
          options={WIDGET_TYPE_OPTIONS}
          placeholder="Select a type"
          disabled={isEdit}
        />
      </Form.Item>
      <Form.Item name="title" label="Title">
        <Input placeholder="Section header shown above the widget" />
      </Form.Item>
      <Form.Item name="description" label="Description">
        <TextArea rows={3} />
      </Form.Item>
      <Form.Item
        name="ordering"
        label="Ordering"
        tooltip="Lower values are shown first"
      >
        <InputNumber min={0} placeholder="0" style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item name="is_active" label="Active" valuePropName="checked">
        <Switch />
      </Form.Item>

      {type === 'callout_card' && !isEdit && (
        <p className="text-gray-500 text-sm mb-4">
          Save first, then fill in the card content on the next screen —
          content needs a widget ID to attach to.
        </p>
      )}

      {type === 'callout_card' && isEdit && (
        <>
          <Divider>Callout Card Content</Divider>
          <Form.Item name="card_title" label="Card Title">
            <Input />
          </Form.Item>
          <Form.Item name="card_description" label="Card Description">
            <TextArea rows={2} />
          </Form.Item>
          <Form.Item
            name="card_screen_name"
            label="Screen Name"
            tooltip="In-app screen to navigate to when the card is tapped"
          >
            <Input />
          </Form.Item>
          <Form.Item name="card_external_link" label="External Link">
            <Input />
          </Form.Item>
          <Form.Item name="card_theme" label="Theme">
            <Input />
          </Form.Item>
          <Form.Item
            name="card_photo"
            label="Photo URL"
            tooltip="Full absolute image URL — no upload, paste a hosted URL"
          >
            <Input />
          </Form.Item>
          <Form.Item name="card_button_label" label="Button Label">
            <Input />
          </Form.Item>
        </>
      )}

      <Form.Item {...tailFormItemLayout}>
        <Button type="primary" htmlType="submit" loading={submiting}>
          Save
        </Button>
      </Form.Item>
    </Form>
  );
};

export default HomeWidgetForm;
